module.exports = __webpack_public_path__ + "static/media/banner-m.e2c40210.png";